<template>
  <div :class="spinnerClasses" role="status">
    <span v-if="label" class="visually-hidden">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "BaseSpinner",
  inheritAttrs: false,
  props: {
    /** ‘border’ (default) or ‘grow’ */
    type: {
      type: String,
      default: "border",
      validator: (v) => ["border", "grow"].includes(v),
    },
    /** Bootstrap contextual color */
    variant: {
      type: String,
      default: "primary",
    },
    /** Accessible text, e.g. “Loading…” */
    label: {
      type: String,
      default: "Loading…",
    },
    /** Show the smaller spinner */
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    spinnerClasses() {
      const cls = [];
      // Base spinner class
      cls.push(this.type === "grow" ? "spinner-grow" : "spinner-border");
      // small variant
      if (this.small) {
        cls.push(
          this.type === "grow" ? "spinner-grow-sm" : "spinner-border-sm"
        );
      }
      // color
      if (this.variant) {
        cls.push(`text-${this.variant}`);
      }
      return cls;
    },
  },
};
</script>
